import { algerianWilayas } from '@/data/wilayas';
import type { WilayaRepository } from '../wilaya.repository';

export const staticWilayaRepository: WilayaRepository = {
  list: () => algerianWilayas,
  findByCode: (code) => algerianWilayas.find((wilaya) => wilaya.code === code) ?? null,
};
